<template>
  <gs-wizard-step>
    <p-row>
      <p-col xs12 lg6>
        <p>
          {{ $t('memberPortal.linkMembership.label.confirmationText') }}
        </p>
      </p-col>
    </p-row>
  </gs-wizard-step>
  </gs-wizard-step>
</template>

<script lang="ts">
  import Vue from 'vue';
  import rsWizardStep from '@/src/components/processes/gs-wizard-step.vue';
  import LinkMembershipRequestViewModel from '../../../../../services/v1/viewModel/request/Memberships/LinkMembershipRequestViewModel';

  export default Vue.extend({
    components: { rsWizardStep },
    props: {
      value: { type: Object, default: undefined },
    },
    data: () => ({
    }),
    computed: {
      innerValue: {
        get(): LinkMembershipRequestViewModel {
          return this.value ?? {};
        },
        set(value: LinkMembershipRequestViewModel) {
          this.$emit('input', value);
        },
      },
    },
  });
</script>
